import React, { useState, useEffect } from 'react';
import {
    Container,
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    Button,
    Form,
    FormGroup,
    Input,
    Label,
    Alert,
} from 'reactstrap';
import moment from 'moment';
import { apiURL } from '../../config';
import Footer from 'components/Footers/Footer';

const OpeningBalanceManagement = () => {
    const token = localStorage.getItem("token");

    const [month, setMonth] = useState(moment().month() + 1); // 1-indexed month
    const [year, setYear] = useState(moment().year());
    const [bank, setBank] = useState('');
    const [monthly, setMonthly] = useState('');
    const [openingBalance, setOpeningBalance] = useState(null);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const baseURL = apiURL;

    useEffect(() => {
        fetchOpeningBalance();
    }, [month, year]);

    const fetchOpeningBalance = async () => {
        try {
            const response = await fetch(`${baseURL}/superadmin/get-opening?month=${month}&year=${year}`, {
                method: 'GET', // or any other HTTP method as needed
                headers: {
                    'Authorization': `Bearer ${token}`, // Add token to headers
                    // Any other headers can go here
                },
            });
            if (response.status === 404) {
                setOpeningBalance(null);
            } else if (response.ok) {
                const data = await response.json();
                setOpeningBalance(data);
                setBank(data.bank);
                setMonthly(data.monthly);
                setError(null);
            } else {
                setError('Error fetching opening balance');
                setOpeningBalance(null);
            }
        } catch (error) {
            setError('Error fetching opening balance');
            console.error('Error fetching opening balance:', error);
            setOpeningBalance(null);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);

        if (!bank || !monthly) {
            setError('Please enter both bank and Cash opening balances.');
            return;
        }

        try {
            let response;
            if (openingBalance) {
                // Edit existing opening balance
                response = await fetch(`${baseURL}/superadmin/edit-opening/${openingBalance._id}?month=${month}&year=${year}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`, // Add token to headers

                    },
                    body: JSON.stringify({ bank, monthly }),
                });
            } else {
                // Add new opening balance
                response = await fetch(`${baseURL}/superadmin/add-opening`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`, // Add token to headers

                    },
                    body: JSON.stringify({ month, year, bank, monthly }),
                });
            }

            if (response.ok) {
                setSuccess('Opening balance saved successfully!');
                fetchOpeningBalance(); // Refresh the opening balance
            } else {
                const errorData = await response.json();
                setError(errorData.message || 'Error saving opening balance');
            }
        } catch (error) {
            setError('Error saving opening balance');
            console.error('Error saving opening balance:', error);
        }
    };

    return (
        <>
            <div
                className="header   d-flex align-items-center"
                style={{
                    minHeight: "600px",
                    backgroundImage:
                        "url(" + require("../../assets/img/theme/alRehman.jpg") + ")",
                    backgroundSize: "cover",
                    backgroundPosition: "center top",
                }}
            >
                <span className="mask bg-gradient-default opacity-8" />
                <Container className="d-flex align-items-center" fluid>
                    <Row>
                        <Col lg="7" md="10">
                            <h1 className="display-4 text-white">Opening Balance Management</h1>
                            <p className="text-white mt-0 mb-5">
                                Add or edit initial opening balances for your organization.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Container className="mt--7" fluid>
                <Row>
                    <Col>
                        <Card className="shadow">
                            <CardHeader className="border-0">
                                <h3 className="mb-0">Opening Balance Details</h3>
                            </CardHeader>
                            <CardBody>
                                <Form onSubmit={handleSubmit}>
                                    {error && <Alert color="danger">{error}</Alert>}
                                    {success && <Alert color="success">{success}</Alert>}
                                    <Row>
                                        <Col md="4">
                                            <FormGroup>
                                                <Label>Month</Label>
                                                <Input
                                                    type="number"
                                                    value={month}
                                                    onChange={(e) => setMonth(e.target.value)}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="4">
                                            <FormGroup>
                                                <Label>Year</Label>
                                                <Input
                                                    type="number"
                                                    value={year}
                                                    onChange={(e) => setYear(e.target.value)}
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <FormGroup>
                                        <Label>Bank Opening Balance</Label>
                                        <Input
                                            type="number"
                                            value={bank}
                                            onChange={(e) => setBank(e.target.value)}
                                            placeholder="Enter bank opening balance"
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Cash Opening Balance</Label>
                                        <Input
                                            type="number"
                                            value={monthly}
                                            onChange={(e) => setMonthly(e.target.value)}
                                            placeholder="Enter Cash opening balance"
                                        />
                                    </FormGroup>
                                    <Button color="primary" type="submit">
                                        {openingBalance ? 'Update Opening Balance' : 'Add Opening Balance'}
                                    </Button>
                                </Form>
                                <hr />
                                {openingBalance ? (
                                    <>
                                        <h4>Current Opening Balance</h4>
                                        <p><strong>Month:</strong> {openingBalance.month}</p>
                                        <p><strong>Year:</strong> {openingBalance.year}</p>
                                        <p><strong>Bank:</strong> {openingBalance.bank}</p>
                                        <p><strong>Cash:</strong> {openingBalance.monthly}</p>
                                        <p><strong>Overall:</strong> {openingBalance.overall}</p>
                                    </>
                                ) : (
                                    <p>No opening balance found for the selected month and year. Add one above!</p>
                                )}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Footer />
            </Container>
        </>
    );
};

export default OpeningBalanceManagement;